//@ts-check

/** @type {string} */
export const APP_NAME = 'Boundless Trends VMS';

/** @type {string} */
export const API_BASE_URL = import.meta.env.VITE_API_URL ?? '/api';
